import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Slider from '@mui/material/Slider';
import Bs4GenericField from './Bs4GenericField';
import { Typography } from '@mui/material';

export default class Bs4Number extends Bs4GenericField {

  getValueBs4() {
    return this.getValue();
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || '');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const decimals = parseInt(this.props.field.decimals) || 0;

    this.refFocus = React.useRef();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || '');
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);
        
    const handleChange = (event, value, activeThumb) => {           
      this.setValue(event.target.value);
    }

    const valuetext = (value) => {
      return new String(Number(value)).replace('.', ',');
    }

    // console.log('...Bs4Number...', this, this.props)

    return (
      <FormControl fullWidth  error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Typography>{valuetext(value)}</Typography>
        <Slider 
          inputRef={this.refFocus}
          value={Number(value)} 
          valueLabelFormat={valuetext}
          min={Number(formField.props?.field?.minValue || 0)} 
          max={Number(formField.props?.field?.maxValue || 100)} 
          step={1}
          onChange={handleChange} 
          valueLabelDisplay='auto'
          size='small'
        />
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}